import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { RouterModule, Routes } from '@angular/router';
import { SetupCompleteComponent } from '@app/setup-complete/setup-complete.component';
import { authGuard } from '@app/service/guards/auth.guard';
import { preventLoginGuard } from '@app/service/guards/prevent-login.guard';

const routes: Routes = [
  {
    path: '', 
    component: LayoutComponent,
    children: [
      { 
        path: '',
        loadChildren: () => import('../mars-setup/mars-setup.module').then(m => m.MarsSetupModule),
        canActivate: [authGuard]
      },
      {
        path: 'login',
        loadChildren: () => import('../login/login.module').then((m => m.LoginModule)),
        canActivate: [preventLoginGuard]
      },
      { path: 'complete', component: SetupCompleteComponent,canActivate: [authGuard]},
      {
        path: 'presets',
        loadChildren: () => import('../presets/presets.module').then(m => m.PresetsModule)
      }
    ]
  }
]

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    SetupCompleteComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ]
})
export class LayoutModule { }
